/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import PropTypes from 'prop-types';
import {PureComponent} from 'react';
import ContactUs from 'Component/ContactUs';
import CmsBlock from 'Component/CmsBlock';
import Html from 'Component/Html';
import Popup from 'Component/Popup';
import Link from 'SourceComponent/Link';
import RenderWhenVisible from 'SourceComponent/RenderWhenVisible';

import {CALL_ME_BACK_POPUP_ID} from './CallMeBackPopup.config';

import './CallMeBackPopup.style';
import CmsBlockFetcherWrapper from "../CmsBlockFetcherWrapper";

/** @namespace Component/CallMeBackPopup/Component */
export class CallMeBackPopup extends PureComponent {
    static propTypes = {
        openCallMeBackPopup: PropTypes.func.isRequired
    };
    state = {};

    renderContent() {
        const {blocks: {items: {callmeback_popup_image_block, callmeback_popup_info_block}}} = this.props;
        return (<RenderWhenVisible fallback={() => <div/>}>
                <CmsBlockFetcherWrapper identifiers={['callmeback_popup_image_block', 'callmeback_popup_info_block']}>
                    <div className="CallMeBackPopup-cols">
                        <div className="CallMeBackPopup-col">
                            {callmeback_popup_image_block && <Html content={callmeback_popup_image_block.content}/>}
                        </div>
                        <div className="CallMeBackPopup-col">
                            <div className="CallMeBackPopup-content">
                                {callmeback_popup_info_block && <Html content={callmeback_popup_info_block.content}/>}
                                <ContactUs popupClose={true}/>
                            </div>
                        </div>
                    </div>
                </CmsBlockFetcherWrapper>
            </RenderWhenVisible>);
    }

    renderPopupContent() {
        return (<Popup
                id={CALL_ME_BACK_POPUP_ID}
                clickOutside={false}
                mix={{block: 'CallMeBackPopup'}}
            >
                {this.renderContent()}
            </Popup>);
    }

    renderPopupButton() {
        const {openCallMeBackPopup, showCallButton} = this.props;

        if (!showCallButton) {
            return null
        }

        return (<Link to={'/'} block="Footer" elem="LinkArrow" className="Footer-LinkArrow-icon"
                      onClick={openCallMeBackPopup}>
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M22.6667 2.66675H9.33341C7.86066 2.66675 6.66675 3.86066 6.66675 5.33341V26.6667C6.66675 28.1395 7.86066 29.3334 9.33341 29.3334H22.6667C24.1395 29.3334 25.3334 28.1395 25.3334 26.6667V5.33341C25.3334 3.86066 24.1395 2.66675 22.6667 2.66675Z"
                        stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 24H16.0133" stroke="white" strokeWidth="2" strokeLinecap="round"
                          strokeLinejoin="round"/>
                </svg>
                <strong>{__('Call me back')} </strong>
            </Link>);
    }

    render() {
        return (<>
                {this.renderPopupButton()}
                {this.renderPopupContent()}
            </>);
    }
}

export default CallMeBackPopup;
